import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { AppStoreContext, appStore } from "./stores/AppStore";

import i18n from "./i18n" ;
import { RateStoreContext, rateStore } from "./stores/RateStore";
import { ResumeStoreContext, resumeStore } from "./stores/ResumeStore";
import { ROUTES } from "./stores/routes";
import qs from "query-string";
import cookie from "js-cookie";
import { GLOBAL_MODALS } from "./stores/modals";
import { SESSION_COOKIE_NAME } from "./shared/config";
const query = qs.parse(document.location.search);

if (process.env.NODE_ENV === "development" && !!query.cmId) {
  cookie.set(SESSION_COOKIE_NAME, query.cmId);
}

appStore.campaign = query.campaign || "";
appStore.referralToken =  query.referralToken;
appStore.referredByPersonId = query.referredByPersonId;
appStore.loadCountries().then(() => appStore.loadUser().then(initialize));

function initialize(userData) {

  i18n.changeLanguage(appStore.locale);

  // init store specific data from the loaded user
  resumeStore.init(userData);
  rateStore.init(userData);

  // initial route
  if (!userData.registerDateUTC) {
    appStore.currentRoute = ROUTES.REGISTER;
  } else if ((!appStore.isProfileProcessing) && (!userData.linkedInProfileUrl || (!userData.resumeReceivedUTC && !userData.resumeURL) || resumeStore.resumeIsStale)) {
    appStore.currentRoute = ROUTES.RESUME;
  } else if (!userData.rateAmount) {
    appStore.currentRoute = ROUTES.RATE;
  } else if (
    (!appStore.reminderDateUTC || new Date(appStore.reminderDateUTC) < new Date()) // no pending reminder
    && !appStore.hasTNC // not signed
    && !appStore.isProfileProcessing // not deeplinked indicating profile is processing
    ) {
    appStore.globalModal = GLOBAL_MODALS.WHATS_NEXT;
    appStore.currentRoute = ROUTES.NONE;
  } else if (!!appStore.hasTNC && !appStore.isProfileProcessing) {
    // already T&C'd, just go to redirect
    appStore.currentRoute = ROUTES.NONE;
    appStore.goToRedirector();
  } else {
    appStore.currentRoute = ROUTES.THANK_YOU;
  }

  ReactDOM.render(
    <Suspense fallback={<div className='ui massive active centered text loader'>Loading</div>}>
      <AppStoreContext.Provider value={appStore}>
        <RateStoreContext.Provider value={rateStore}>
          <ResumeStoreContext.Provider value={resumeStore}>
            <App />
          </ResumeStoreContext.Provider>
        </RateStoreContext.Provider>
      </AppStoreContext.Provider>
    </Suspense>,
    document.getElementById("root")
  );
}

// need default export for lazy-loading
const lazyLoad = true;
export default lazyLoad;
